var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{ name: '', params: {} }}},[_vm._v("Restaurant name")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }